/**
 * @deprecated Do not use this!
 */
export function isElement(element: any) { // eslint-disable-line
	return element instanceof Element || element instanceof Document || element instanceof Window;
}